import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContratoFasonComponent } from './contrato-fason.component';


@NgModule({
  declarations: [
    ContratoFasonComponent
  ],
  imports: [
    CommonModule
  ], exports: [
    ContratoFasonComponent
  ]
})
export class ContratoFasonModule { }
